'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { MarketPrompt, MarketImage } from './market-primitives';
import { U, MarketReveal } from './collection-animation';
import { hu, mu, gu, fu, _u, pu } from './campaign-kit';
import { ShowcaseIcon } from './scene-primitives';
import { referenceImages } from './reference-brands';
import { ShowcaseSpinner } from './playback-controls';
import { ge } from './reference-products';
export function LaunchPlan({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex flex-col gap-4'}>
      <MarketPrompt
        t={e}
        workflow={'Plan a Launch'}
        brand={'aubrac'}
        prompt={`${U.ref}, launching ${U.launch}`}
        doneAt={hu.done}
        busy={'Planning the launch'}
        result={'Launch plan ready'}
        meta={`${mu.length} workstreams`}
      />
      <MarketReveal on={e >= hu.card} className={'mk-card p-3 sm:p-4'}>
        <div className={'flex flex-wrap items-center justify-between gap-2'}>
          <div className={'min-w-0'}>
            <p className={'text-ink text-[14px] leading-5 font-medium'}>
              {translateShowcaseNode(
                showcaseCopy,
                'The coat dress \xB7 FW27 launch'
              )}
            </p>
            <p className={'text-ink-3 text-[12px] leading-4'}>
              {translateShowcaseNode(
                showcaseCopy,
                'Store, email and social \xB7 illustrative dates'
              )}
            </p>
          </div>
          <MarketReveal
            on={e >= gu}
            pop={!0}
            className={
              'text-ink inline-flex h-7 items-center gap-1.5 rounded-full bg-[var(--state-wash)] px-2.5 text-[12px] font-medium'
            }
          >
            <ShowcaseIcon name={'clock'} className={'size-3.5'} />
            {translateShowcaseNode(showcaseCopy, 'Launch ')}
            {translateShowcaseNode(showcaseCopy, U.launch)}
          </MarketReveal>
        </div>
        <div
          className={'mt-4 grid grid-cols-1 sm:grid-cols-[148px_minmax(0,1fr)]'}
        >
          <span className={'max-sm:hidden'} />
          <div className={'relative grid grid-cols-7 pb-2'}>
            {translateShowcaseNode(
              showcaseCopy,
              fu.map((t, n) => (
                <MarketReveal
                  key={t}
                  on={e >= hu.grid}
                  delay={n * 40}
                  className={
                    'num text-ink-4 text-[11px] leading-4 sm:text-[12px]'
                  }
                >
                  {translateShowcaseNode(showcaseCopy, t)}
                </MarketReveal>
              ))
            )}
          </div>
          {translateShowcaseNode(
            showcaseCopy,
            mu.map((t, n) => {
              let r = e >= hu.lane + n * hu.laneStep;
              return (
                <div key={t.name} className={'contents'}>
                  <MarketReveal
                    on={r}
                    className={
                      'text-ink flex h-9 items-center truncate text-[13px] max-sm:hidden'
                    }
                  >
                    {translateShowcaseNode(showcaseCopy, t.name)}
                  </MarketReveal>
                  <div className={'relative h-12 sm:h-9'}>
                    <span
                      aria-hidden={!0}
                      className={'absolute inset-0 grid grid-cols-7'}
                    >
                      {translateShowcaseNode(
                        showcaseCopy,
                        fu.map((e) => (
                          <span
                            key={e}
                            className={
                              'border-l border-dashed border-[var(--line)]'
                            }
                          />
                        ))
                      )}
                    </span>
                    <MarketReveal
                      on={r}
                      className={
                        'text-ink absolute top-1 left-1.5 text-[12px] leading-4 sm:hidden'
                      }
                    >
                      {translateShowcaseNode(showcaseCopy, t.name)}
                    </MarketReveal>
                    <span
                      data-on={r}
                      className={
                        'mk-grow absolute bottom-1.5 flex h-6 items-center overflow-hidden rounded-[6px] bg-[color-mix(in_oklch,var(--primary)_10%,transparent)] px-2 shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--primary)_14%,transparent)]'
                      }
                      style={{
                        left: _u(t.from),
                        width: _u(t.to - t.from),
                      }}
                    >
                      <span
                        className={
                          'text-ink-3 truncate text-[11px] leading-4 max-sm:hidden'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, t.owner)}
                      </span>
                    </span>
                    <span
                      data-on={e >= gu}
                      aria-hidden={!0}
                      className={
                        'mk-grow-y absolute inset-y-0 w-px bg-[var(--primary)]'
                      }
                      style={{
                        left: _u(pu),
                        transitionDelay: e >= gu ? `${n * 45}ms` : void 0,
                      }}
                    />
                  </div>
                </div>
              );
            })
          )}
        </div>
        <MarketReveal
          on={e >= hu.done}
          className={
            'mt-3 flex flex-wrap gap-x-5 gap-y-1 text-[12px] leading-4'
          }
        >
          <span className={'text-ink-3'}>
            {translateShowcaseNode(showcaseCopy, 'Content locked ')}
            <span className={'num text-ink'}>
              {translateShowcaseNode(showcaseCopy, 'Feb 27')}
            </span>
          </span>
          <span className={'text-ink-3'}>
            {translateShowcaseNode(showcaseCopy, 'Publishing ')}
            <span className={'text-ink'}>
              {translateShowcaseNode(showcaseCopy, 'after your approval')}
            </span>
          </span>
          <span className={'text-ink-3'}>
            {translateShowcaseNode(showcaseCopy, 'Read the response ')}
            <span className={'num text-ink'}>
              {translateShowcaseNode(showcaseCopy, 'Mar 26')}
            </span>
          </span>
        </MarketReveal>
      </MarketReveal>
    </div>
  );
}
export const yu = referenceImages.aubrac.listings.map((e, t) => ({
  asset: e,
  label: ['Front', 'Back', 'Side', 'Seam'][t] ?? '',
}));
export const bu = {
  source: 300,
  wire: 650,
  frame: 700,
  frameStep: 110,
  shot: 1250,
  shotStep: 420,
  details: 2900,
};
export const xu = bu.shot + yu.length * bu.shotStep;
export const Su = [
  ['Views', 'Front, back, side, seam'],
  ['Background', 'White studio'],
  ['Ratio', '1:1'],
  ['Saved to', 'Aubrac / FW27 / Listing'],
];
export function ListingImages({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex flex-col gap-4'}>
      <MarketPrompt
        t={e}
        workflow={'Create Product Listing Images'}
        brand={'aubrac'}
        prompt={`${U.ref}, from the approved product`}
        doneAt={xu}
        busy={'Making listing images'}
        result={'4 listing images'}
        meta={'On white \xB7 1:1'}
      />
      <div
        className={
          'grid items-start gap-3 sm:grid-cols-[160px_minmax(0,1fr)] sm:gap-5 lg:grid-cols-[180px_minmax(0,1fr)_200px]'
        }
      >
        <MarketReveal on={e >= bu.source} className={'flex gap-3 sm:flex-col'}>
          <span
            className={'relative block w-16 shrink-0 sm:w-[160px] lg:w-full'}
          >
            <MarketImage
              asset={U.kit.launch}
              focus={'50% 40%'}
              alt={translateShowcaseNode(
                showcaseCopy,
                `${U.product}, the approved product`
              )}
              className={'aspect-[4/5] rounded-[10px] bg-[var(--muted)]'}
            />
            <span
              className={
                'pop text-ink absolute top-1.5 left-1.5 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] leading-4 font-medium max-sm:hidden'
              }
            >
              <ShowcaseIcon
                name={'check'}
                className={'size-3'}
                strokeWidth={2}
              />
              {translateShowcaseNode(showcaseCopy, 'Approved')}
            </span>
          </span>
          <span
            className={
              'flex min-w-0 flex-col justify-center sm:max-w-[160px] lg:max-w-none'
            }
          >
            <span className={'text-ink text-[13px] leading-5 font-medium'}>
              {translateShowcaseNode(showcaseCopy, U.product)}
            </span>
            <span className={'text-ink-3 text-[12px] leading-4'}>
              {translateShowcaseNode(
                showcaseCopy,
                'Approved product \xB7 source'
              )}
            </span>
            <span
              data-on={e >= bu.wire}
              aria-hidden={!0}
              className={
                'mk-grow mt-2 block h-px w-full bg-[var(--border)] max-sm:hidden'
              }
            />
          </span>
        </MarketReveal>
        <ul
          className={'grid grid-cols-2 gap-2 sm:gap-2.5 lg:grid-cols-4'}
          aria-label={translateShowcaseNode(showcaseCopy, 'Listing images')}
        >
          {translateShowcaseNode(
            showcaseCopy,
            yu.map((t, n) => {
              let r = e >= bu.shot + n * bu.shotStep;
              return (
                <MarketReveal
                  key={t.label}
                  as={'li'}
                  pop={!0}
                  on={e >= bu.frame + n * bu.frameStep}
                  className={'flex min-w-0 flex-col gap-1'}
                >
                  <span
                    className={
                      'relative block aspect-square overflow-hidden rounded-[10px] bg-white'
                    }
                  >
                    <span
                      className={
                        'text-ink-3 absolute inset-0 grid place-items-center transition-opacity duration-200'
                      }
                      style={{
                        opacity: +!r,
                      }}
                    >
                      {translateShowcaseNode(
                        showcaseCopy,
                        r ? null : <ShowcaseSpinner className={'size-4'} />
                      )}
                    </span>
                    <MarketReveal
                      on={r}
                      pop={!0}
                      className={'absolute inset-0'}
                    >
                      <MarketImage
                        asset={t.asset}
                        alt={translateShowcaseNode(
                          showcaseCopy,
                          `${U.product}: ${t.label}`
                        )}
                        className={'size-full'}
                      />
                    </MarketReveal>
                    <span
                      aria-hidden={!0}
                      className={'mk-outline rounded-[10px]'}
                    />
                  </span>
                  <span
                    className={
                      'flex items-baseline justify-between px-0.5 text-[12px] leading-4'
                    }
                  >
                    <span className={'text-ink truncate'}>
                      {translateShowcaseNode(showcaseCopy, t.label)}
                    </span>
                    <span className={'num text-ink-4'}>
                      {translateShowcaseNode(
                        showcaseCopy,
                        String(n + 1).padStart(2, '0')
                      )}
                    </span>
                  </span>
                </MarketReveal>
              );
            })
          )}
        </ul>
        <MarketReveal
          on={e >= bu.details}
          className={'mk-card p-3 max-lg:hidden'}
        >
          <dl className={'flex flex-col gap-2.5'}>
            {translateShowcaseNode(
              showcaseCopy,
              Su.map(([e, t]) => (
                <div key={e}>
                  <dt className={'label'}>
                    {translateShowcaseNode(showcaseCopy, e)}
                  </dt>
                  <dd className={'num text-ink text-[13px] leading-5'}>
                    {translateShowcaseNode(showcaseCopy, t)}
                  </dd>
                </div>
              ))
            )}
          </dl>
        </MarketReveal>
      </div>
    </div>
  );
}
export const K = {
  frame: 300,
  subject: 600,
  preview: 1250,
  mark: 900,
  hero: 1150,
  headline: 1700,
  cta: 2050,
  section: 2500,
  links: 3100,
  scrollFrom: 2200,
  scrollTo: 3500,
  side: 2400,
  done: 3700,
};
export const wu = ge.subject;
export const Tu = ge.preheader;
export const Eu = (e) => {
  let t = ge.blocks.find((t) => t.kind === e);
  return t && 'text' in t ? t.text : '';
};
export const Du = '#FBF9F5';
export const Ou = '#2B2522';
export const ku = '#857A6E';
export const Au = '#E6DFD4';
